// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"ac100c89","88":"8be46a61","622":"5dcbc618","824":"691ffa33"}[chunkId] + ".chunk.js";
};